var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 1.79086 7.79086 0 10 0H14C16.2091 0 18 1.79086 18 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H21.9513L21.3363 18.2996C21.1766 21.4929 18.541 24 15.3438 24H8.65624C5.459 24 2.82339 21.4929 2.66373 18.2996L2.04875 6H1C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4H6ZM4.05125 6L4.66124 18.1997C4.76768 20.3286 6.52475 22 8.65624 22H15.3438C17.4752 22 19.2323 20.3286 19.3388 18.1997L19.9487 6H4.05125ZM16 4H8C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4ZM9 10C9.55229 10 10 10.4477 10 11V16C10 16.5523 9.55229 17 9 17C8.44772 17 8 16.5523 8 16V11C8 10.4477 8.44772 10 9 10ZM15 10C15.5523 10 16 10.4477 16 11V16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16V11C14 10.4477 14.4477 10 15 10Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDelete);
export default __webpack_public_path__ + "static/media/red-delete.0ce296d2b71d1cb81776679629d2e788.svg";
export { ForwardRef as ReactComponent };